<template>
    <themed-modal
        name="contact-edit"
        title="Edit Contact"
        size="lg"
        @closed="handleClosed"
    >
        <themed-form
            :fields="formFields"
            :model-value="localContact"
            :errors="errors"
            layout="grid"
            :columns="3"
            @input="localContact = $event"
        />

        <template #footer>
            <div class="modal-actions">
                <themed-button
                    variant="secondary"
                    @click="hideModal"
                >
                    Cancel
                </themed-button>
                <themed-button
                    variant="default"
                    :disabled="loading"
                    @click="updateContact"
                >
                    {{ loading ? 'Saving...' : 'Save Contact' }}
                </themed-button>
            </div>
        </template>
    </themed-modal>
</template>

<script>
import { mapState } from 'vuex';
import ThemedModal from '../ThemedModal.vue';
import ThemedForm from '../form/ThemedForm.vue';
import ThemedButton from '../ThemedButton.vue';

export default {
    name: 'EditContactModal',
    
    components: {
        ThemedModal,
        ThemedForm,
        ThemedButton
    },

    props: {
        contact: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            localContact: {},
            errors: {},
            loading: false,
            formFields: [
                {
                    name: 'name',
                    type: 'input',
                    label: 'Name',
                    placeholder: 'Enter contact name',
                    required: true,
                    col: 1
                },
                {
                    name: 'type',
                    type: 'select',
                    label: 'Type',
                    placeholder: 'Select type',
                    options: [
                        { value: '', label: 'Select type' },
                        { value: 'Broker', label: 'Broker' },
                        { value: 'Owner', label: 'Owner' },
                        { value: 'Property Manager', label: 'Property Manager' },
                        { value: 'Municipality', label: 'Municipality' },
                        { value: 'Developer', label: 'Developer' },
                        { value: 'Other', label: 'Other' }
                    ],
                    col: 1
                },
                {
                    name: 'title',
                    type: 'input',
                    label: 'Title',
                    placeholder: 'Enter title',
                    col: 1
                },
                {
                    name: 'email',
                    type: 'input',
                    inputType: 'email',
                    label: 'Email',
                    placeholder: 'john@example.com',
                    col: 1
                },
                {
                    name: 'phone',
                    type: 'input',
                    inputType: 'tel',
                    label: 'Phone',
                    placeholder: '(555) 555-5555',
                    col: 1
                },
                {
                    name: 'extension',
                    type: 'input',
                    label: 'Ext.',
                    placeholder: '123',
                    col: 1
                },
                {
                    name: 'cell',
                    type: 'input',
                    inputType: 'tel',
                    label: 'Cell',
                    placeholder: '(555) 555-5555',
                    col: 1
                },
                {
                    name: 'fax',
                    type: 'input',
                    inputType: 'tel',
                    label: 'Fax',
                    placeholder: '(555) 555-5555',
                    col: 2
                },
                {
                    name: 'comments',
                    type: 'textarea',
                    label: 'Comments',
                    placeholder: 'Enter any additional comments',
                    rows: 4,
                    col: 3
                }
            ]
        };
    },

    computed: {
        ...mapState(['contacts'])
    },

    watch: {
        contact: {
            immediate: true,
            handler(newContact) {
                if (newContact) {
                    this.localContact = { ...newContact };
                }
            }
        }
    },

    methods: {
        hideModal() {
            this.$modal.hide('contact-edit');
        },

        handleClosed() {
            this.errors = {};
            this.loading = false;
        },

        updateContact() {
            this.loading = true;
            this.errors = {};

            this.$store.dispatch('saveContact', this.localContact)
                .then(() => {
                    this.$emit('contact-updated', this.localContact);
                    
                    this.$notify({
                        type: 'success',
                        title: 'Success',
                        text: 'Contact Updated'
                    });

                    this.hideModal();
                })
                .catch((error) => {
                    console.error(error);
                    if (error.response?.data?.errors) {
                        this.errors = error.response.data.errors;
                    }
                    
                    this.$notify({
                        type: 'error',
                        title: 'Error',
                        text: error.response?.data?.message || 'Failed to update contact'
                    });
                })
                .finally(() => {
                    this.loading = false;
                });
        }
    }
};
</script>
